import React from "react";

const QuotedContent = ({ author, content }) => {
  if (!author || !content) return null;

  return (
    <blockquote className="p-3 bg-gray-50 border-l-4 border-rose-700 mb-4 rounded">
      <p className="text-sm text-gray-500 mb-1">
        <span className="font-medium text-blue-500">{author}</span> wrote:
      </p>
      <p className="text-sm text-gray-700">{content}</p>
    </blockquote>
  );
};

export default QuotedContent;